import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Styles/AdminViewReports.css";
import Loader from "../../Components/Loader";
function ReportHistory() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    fetchResolvedReports();
  }, []);

  const fetchResolvedReports = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.get(
        "https://api.uniums.com/api/reports/resolved-reports",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setReports(response.data.resolvedReports);
    } catch (error) {
      console.error("Error fetching resolved reports:", error);
      toast.error("Failed to fetch resolved reports.");
    } finally {
      setLoading(false);
    }
  };

  // Filter reports based on search input
  const filteredReports = reports.filter(
    (report) =>
      report.UserId?.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      report.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      report.issueType.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="admin-container">
      <ToastContainer />
      <h1>Resolved Reports History</h1>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name, title, or issue type..."
          className="search-box"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {loading ? (
        <>
          <p className="loading">Loading resolved reports...</p>
          <Loader />
        </>

      ) : (
        <div className="faculty-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Issue Type</th>
                <th>Urgency</th>
                <th>Title</th>
                <th>Description</th>
                <th>Screenshot</th>
                <th>Status</th>
                <th>Remark</th>
                <th>Issue Date</th>
                <th>Resolved Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredReports.length > 0 ? (
                filteredReports.map((report, index) => (
                  <tr key={report._id}>
                    <td>{index + 1}</td>
                    <td>{report.UserId?.name || "Unknown"}</td>
                    <td>{report.issueType}</td>
                    <td>{report.urgency}</td>
                    <td
                      style={{
                        padding: "10px",
                        minWidth: "200px",
                        maxWidth: "200px",
                        maxHeight: "200px",
                        overflow: "auto",
                        whiteSpace: "normal",
                      }}
                    >
                      {report.title}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        minWidth: "200px",
                        maxWidth: "200px",
                        maxHeight: "200px",
                        overflow: "auto",
                        display: "block",
                        whiteSpace: "normal",
                      }}
                    >
                      {report.description}
                    </td>
                    <td>
                      {report.fileUrl ? (
                        <a
                          href={report.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={report.fileUrl}
                            alt="Screenshot"
                            className="screenshot"
                          />
                        </a>
                      ) : (
                        "No Screenshot"
                      )}
                    </td>
                    <td
                      style={{
                        width: "250px",
                        height: "100px",
                        padding: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        resize: "none",
                      }}
                    >
                      {report.status}
                    </td>
                    <td>{report.remark}</td>
                    <td>
                      {new Date(report.createdAt).toLocaleDateString("en-GB")}
                    </td>
                    <td>
                      {new Date(report.updatedAt).toLocaleDateString("en-GB")}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="no-data">
                    No resolved reports found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ReportHistory;
